import React from 'react';
import { 
  Shield, 
  Info, 
  Clock,
  Lock,
  Eye,
  Cookie,
  Mail,
  Server,
  ExternalLink 
} from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-gray-100 pt-24">
      {/* Minimal Header */}
      <header className="bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center space-x-3">
            <Shield className="w-6 h-6 text-blue-500" />
            <h1 className="text-2xl font-semibold text-gray-800">Privacy Policy</h1>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        {/* Last Updated Notice */}
        <div className="flex items-center text-sm text-gray-500 mb-8">
          <Clock className="w-4 h-4 mr-2" />
          Last updated: January 21, 2025
        </div>

        {/* Introduction Card */}
        <div className="bg-blue-50 border border-blue-100 rounded-xl p-6 mb-8">
          <div className="flex items-start">
            <Info className="w-5 h-5 text-blue-500 mt-1 mr-4 flex-shrink-0" />
            <p className="text-sm text-blue-700">
              At Gortherm, we take your privacy seriously. This Privacy Policy explains how we collect,
              use, disclose, and safeguard your information when you use our services.
            </p>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Information We Collect</h2>
              <p className="text-gray-600 leading-relaxed">
                We collect information that you provide directly to us, including but not limited to
                your name, email address, and any other information you choose to provide. We also
                automatically collect certain information about your device when you use our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">2. Use of Information</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                We use the information we collect to provide, maintain, and improve our services,
                to communicate with you, and to detect, prevent, and address technical issues.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Your information helps us to personalize your experience and to send you relevant
                notifications about service updates and changes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Data Security</h2>
              <p className="text-gray-600 leading-relaxed">
                We implement appropriate technical and organizational measures to maintain the safety
                of your personal information. However, no method of transmission over the Internet
                or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Cookies and Tracking</h2>
              <p className="text-gray-600 leading-relaxed">
                We use cookies and similar tracking technologies to track activity on our service
                and hold certain information. You can instruct your browser to refuse all cookies
                or to indicate when a cookie is being sent.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Third-Party Services</h2>
              <p className="text-gray-600 leading-relaxed">
                Our service may contain links to third-party websites or services that are not
                owned or controlled by us. We have no control over and assume no responsibility
                for the content, privacy policies, or practices of any third-party sites or services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Your Rights</h2>
              <p className="text-gray-600 leading-relaxed">
                You have the right to access, update, or delete your personal information at any
                time. You can also object to processing of your personal information, ask us to
                restrict processing, or request portability of your information.
              </p>
            </section>
          </div>
        </div>

        {/* Privacy Shield Notice */}
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 mb-8">
          <div className="flex items-start">
            <Lock className="w-5 h-5 text-gray-500 mt-1 mr-4 flex-shrink-0" />
            <p className="text-sm text-gray-600">
              Your privacy is important to us. If you have any questions about our Privacy Policy
              or how we handle your personal information, please contact our privacy team.
            </p>
          </div>
        </div>

        {/* Contact Section */}
        
      </main>
    </div>
  );
};

export default PrivacyPolicy;